import { useSetImmerAtom } from 'jotai-immer';
import { useAtomValue } from 'jotai';
import { useEffect, useState } from 'react';
import { feedsSearchFormAtom } from './feeds_search_atoms';
import { feedsSearchStateVM } from './feeds_search_view_models';
import { getLocalToday } from '../../../../core/components/validation/ValidInputDate.utils';
import { FEEDS_LIST_FORM_KEY, feedsUserContextAtom } from '../feeds_list_atoms';
import viewStateRepo from '../../../../core/repo/viewStateRepo';
import { feedsPageActionAtom } from '../feeds_list_atoms';
import { buildDropdownOptions } from '../pagehooks/useFeedsInit';
import { getList, getSourceOptions } from '../../data/feedsRepo';

export const useFeedsSearchInit = (): boolean => {
    const [init, setInit] = useState(true);
    const action = useAtomValue(feedsPageActionAtom);
    const setSearchForm = useSetImmerAtom(feedsSearchFormAtom);
    const feedsUserContext = useAtomValue(feedsUserContextAtom);

    useEffect(() => {
        if (init && action === 'QUERY') {
            // Build a lightweight ctx shape from the atom for buildDropdownOptions
            const ctx = { User: { AffList: feedsUserContext.affiliations, Type: feedsUserContext.userType } };
            const options = buildDropdownOptions(ctx);
            const vs = viewStateRepo.getForm(FEEDS_LIST_FORM_KEY);

            const today = getLocalToday();

            const initialDateRangeMode = 'TODAY';
            const initialStartDate = today;
            const initialEndDate = today;

            const vsWithOptions = {
                ...vs,
                facilityOptions: options.facilityOptions,
                pharmacyOptions: options.pharmacyOptions,
                feedTypeOptions: options.feedTypeOptions,
                statusOptions: options.statusOptions,
                sourceOptions: options.sourceOptions,
                DateRangeMode: vs?.DateRangeMode ?? initialDateRangeMode,
                StartDate: vs?.StartDate ?? initialStartDate,
                EndDate: vs?.EndDate ?? initialEndDate,
            };

            const formState = feedsSearchStateVM(vsWithOptions);

            setInit(false);
            setSearchForm(() => formState);

            if (vs) {
                // Unique case where the API requires an empty array but we need
                // to select all in the source field.
                // Turn OFF auto-search for now
                const source = cleanSourceField(vsWithOptions.Source?.val);

                getList(
                    { ...formState, Source: { ...formState.Source, val: source } },
                    feedsUserContext.userType === 'CE',
                );
            }
        }
        /* eslint-disable-next-line */
    }, []);

    return init;
};

export const cleanSourceField = (sourceVal: string[]): string[] => {
    let val = sourceVal;
    if (sourceVal?.length === getSourceOptions().length) {
        val = [];
    }
    return val;
};
